import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MobileMenuItem } from '../../../../shared/interfaces/mobile-menu-item';
import { CollapseItemDirective } from '../../../../shared/directives/collapse.directive';

@Component({
    selector: 'app-mobile-links',
    templateUrl: './mobile-links.component.html',
    styleUrls: ['./mobile-links.component.scss']
})
export class MobileLinksComponent {
    @Input() links: MobileMenuItem[] = [];
    @Input() level = 0;

    @Output() itemClick: EventEmitter<MobileMenuItem> = new EventEmitter();

    constructor() { }

    onItemClick(item: MobileMenuItem): void {
        this.itemClick.emit(item);
    }

    /// A button's label has nowhere to go, so a tap on it opens or closes its children.
    onButtonClick(item: MobileMenuItem, collapse: CollapseItemDirective): void {
        if (item.children && item.children.length > 0) {
            collapse.toggle();
        }
    }
}
